export const addresses = [
	{
		title: 'New York',
		descriptions: ['420 Lexington Avenue', 'New York, New York 10170', '+1 646 631 5979'],
	},
	{
		title: 'Houston',
		descriptions: ['800 Town and Country Blvd. Suite 300', 'Houston, Texas 77024'],
	},
];
